import script from "./ProjectDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDocumentsView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDocumentsView.vue?vue&type=style&index=0&id=673318ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673318ba"]])

export default __exports__